import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromManagement from './management-action.actions';
import { tap, switchMap, flatMap, catchError } from 'rxjs/operators';
import { TimeCardService } from '../time-card.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromDRWTS from '../store/direct-reports-with-time-status.actions';
import * as fromTimecard from './time-card.actions';
import * as fromWeeklySummary from './weekly-summary.actions';
import moment from 'moment';
import * as fromShared from '../../shared';
import { ManagementActionService } from '../managementActionService';

@Injectable()
export class ManagementActionEffects {
    constructor(
        private actions$: Actions,
        @Inject(TimeCardService) private service: TimeCardService,
        @Inject(LoggingService) private log: LoggingService,
        private managementActionService: ManagementActionService
    ) {}

    putManagement$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromManagement.putManagment),
            tap(a =>
                this.log.verbose({ type: 'TimeCardEffects:putManagement$', a })
            ),
            switchMap(a =>
                this.service.putManagementAction(a.managementAction).pipe(
                    flatMap(tcs => {
                        this.managementActionService.setManagementActionResponse(tcs);
                        return [
                            fromManagement.upsertManagementActions({
                                managementActions: tcs.Items
                            }),
                            fromDRWTS.getDirectReportsWithTimeStatus({
                                UserListID: a.managementAction.EmployeeListID,
                                UserRole: a.managementAction.UserGroupID,
                                StartDate: a.managementAction.MgmtDateRangeStart,
                                EndDate: a.managementAction.MgmtDateRangeEnd,
                                MyDRsOnly: a.managementAction.MyDrsOnly
                            }), // can add EmployeeListID to only get back one DR
                            fromTimecard.getTimeCards({
                                EmployeeListID: a.managementAction.usrDirectReports[0].EmployeeListID,
                                // Stay on the week the user was viewing (not period start / cell day).
                                TimeCardDate: moment(
                                    a.managementAction.DisplayedWeekStart ||
                                        a.managementAction.MgmtDateRangeStart ||
                                        a.managementAction.StartDate
                                ).format('MM/DD/YYYY'),
                                MyDirection: null,
                                Processid: a.managementAction.Processid,
                                EndDate: new Date(a.managementAction.MgmtDateRangeEnd)
                            }),
                            fromWeeklySummary.getWeeklySummary({
                                EmployeeListID: a.managementAction.EmployeeListID,
                                DRListID: a.managementAction.usrDirectReports[0].EmployeeListID,
                                StartDate: new Date(a.managementAction.MgmtDateRangeStart),
                                EndDate: new Date(a.managementAction.MgmtDateRangeEnd)
                            })
                        ];
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
